import Mana from './Mana'
import PropTypes from 'prop-types'
import SubNav from './SubNav'
import classNames from 'classnames'
import styles from '../styles/RelatedInfo.module.scss'
import useDarkMode from 'use-dark-mode'

const RelatedInfo = ({ colors, plural, singular, themes, tribes }) => {
  const darkMode = useDarkMode(false)
  return singular ? (
    <div
      className={classNames(styles.container, {
        [styles.dark]: darkMode.value,
      })}
    >
      {colors.length > 0 && (
        <>
          <h4>{`${singular} color combinations`}</h4>
          <SubNav
            items={colors.map(({ count, icons, name, url }) => ({
              image: (
                <span className={styles.row}>
                  <Mana colors={icons.split('')} />
                </span>
              ),
              padLeft: true,
              textLeft: name,
              textRight: `${count} decks`,
              url: url,
            }))}
          />
        </>
      )}
      {themes.length > 0 && (
        <>
          <h4>{`Popular themes for ${plural}`}</h4>
          <SubNav
            items={themes.map(({ art_crop, count, name, url }) => ({
              image: art_crop && (
                <img alt={name} className={styles.artCrop} src={art_crop} />
              ),
              textLeft: name,
              textRight: `${count} decks`,
              url: url,
            }))}
          />
        </>
      )}
      {tribes.length > 0 && (
        <>
          <h4>{`Popular tribes for ${plural}`}</h4>
          <SubNav
            items={tribes.map(({ art_crop, count, name, url }) => ({
              image: art_crop && (
                <img alt={name} className={styles.artCrop} src={art_crop} />
              ),
              textLeft: name,
              textRight: `${count} decks`,
              url: url,
            }))}
          />
        </>
      )}
    </div>
  ) : null
}

RelatedInfo.propTypes = {
  colors: PropTypes.arrayOf(
    PropTypes.shape({
      count: PropTypes.number.isRequired,
      icons: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }).isRequired
  ),
  plural: PropTypes.string,
  singular: PropTypes.string,
  themes: PropTypes.arrayOf(
    PropTypes.shape({
      count: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }).isRequired
  ),
  tribes: PropTypes.arrayOf(
    PropTypes.shape({
      count: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }).isRequired
  ),
}

export default RelatedInfo
